import toast from "react-hot-toast"
import { apiConnector } from "../apiconnector"
import { quizEndpoints } from "../apis"

const {
  UPSERT_QUIZ_API,
  GET_QUIZ_FOR_INSTRUCTOR_API,
  DELETE_QUIZ_API,
  GET_QUIZ_API,
  SUBMIT_QUIZ_API,
  GET_QUIZ_ATTEMPTS_API,
  GET_COURSE_PROGRESS_API,
} = quizEndpoints

const authHeader = (token) => ({ Authorization: `Bearer ${token}` })

//Instructor: the editing view, which does include the answers
export const getQuizForInstructor = async (courseId, token) => {
  try {
    const response = await apiConnector(
      "POST",
      GET_QUIZ_FOR_INSTRUCTOR_API,
      { courseId },
      authHeader(token)
    )

    return response?.data?.data ?? null
  } catch (error) {
    console.log("GET QUIZ (INSTRUCTOR) API ERROR....", error)
    toast.error(error.response?.data?.message || "Could not load the quiz")
    return null
  }
}

export const saveQuiz = async (payload, token) => {
  const toastId = toast.loading("Saving quiz...")
  let success = false

  try {
    const response = await apiConnector("POST", UPSERT_QUIZ_API, payload, authHeader(token))

    if (!response?.data?.success) {
      throw new Error(response?.data?.message)
    }

    toast.success("Quiz saved")
    success = true
  } catch (error) {
    console.log("SAVE QUIZ API ERROR....", error)
    //the server validates each question, and its message names the bad one
    toast.error(error.response?.data?.message || "Could not save the quiz")
  }

  toast.dismiss(toastId)
  return success
}

export const deleteQuiz = async (courseId, token) => {
  const toastId = toast.loading("Deleting quiz...")
  let success = false

  try {
    const response = await apiConnector(
      "DELETE",
      DELETE_QUIZ_API,
      { courseId },
      authHeader(token)
    )

    if (!response?.data?.success) {
      throw new Error(response?.data?.message)
    }

    toast.success("Quiz deleted")
    success = true
  } catch (error) {
    console.log("DELETE QUIZ API ERROR....", error)
    toast.error(error.response?.data?.message || "Could not delete the quiz")
  }

  toast.dismiss(toastId)
  return success
}

//Student: questions without answers. A 403 here is the normal "not finished yet"
//case rather than an error worth shouting about, so it is returned as state.
export const getQuiz = async (courseId, token) => {
  try {
    const response = await apiConnector("POST", GET_QUIZ_API, { courseId }, authHeader(token))
    return { quiz: response.data.data, locked: false, missing: false }
  } catch (error) {
    const status = error.response?.status
    const data = error.response?.data

    if (status === 403 && data?.data?.locked) {
      return { quiz: null, locked: true, missing: false, progress: data.data.progress }
    }

    if (status === 404) {
      return { quiz: null, locked: false, missing: true }
    }

    console.log("GET QUIZ API ERROR....", error)
    toast.error(data?.message || "Could not load the quiz")
    return { quiz: null, locked: false, missing: true }
  }
}

export const submitQuiz = async (courseId, answers, token) => {
  const toastId = toast.loading("Submitting...")
  let result = null

  try {
    const response = await apiConnector(
      "POST",
      SUBMIT_QUIZ_API,
      { courseId, answers },
      authHeader(token)
    )

    if (!response?.data?.success) {
      throw new Error(response?.data?.message)
    }

    result = response.data.data
  } catch (error) {
    console.log("SUBMIT QUIZ API ERROR....", error)
    toast.error(error.response?.data?.message || "Could not submit the quiz")
  }

  toast.dismiss(toastId)
  return result
}

export const getQuizAttempts = async (courseId, token) => {
  try {
    const response = await apiConnector(
      "POST",
      GET_QUIZ_ATTEMPTS_API,
      { courseId },
      authHeader(token)
    )

    return response?.data?.data ?? null
  } catch (error) {
    console.log("GET QUIZ ATTEMPTS API ERROR....", error)
    return null
  }
}

export const getCourseProgress = async (courseId, token) => {
  try {
    const response = await apiConnector(
      "POST",
      GET_COURSE_PROGRESS_API,
      { courseId },
      authHeader(token)
    )

    return response?.data?.data ?? null
  } catch (error) {
    console.log("GET COURSE PROGRESS API ERROR....", error)
    return null
  }
}
